import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { storybookRouteRef } from './routes';

export const dxIframePlugin = createPlugin({
  id: 'dx-iframe',
  routes: {
    root: storybookRouteRef,
  },
});

export const DxIframeStorybookPage = dxIframePlugin.provide(
  createRoutableExtension({
    name: 'DxIframeStorybookPage',
    component: () =>
      import('./components/DxIFrameWithStorybookType').then(
        m => m.DxIFrameWithStorybookType,
      ),
    mountPoint: storybookRouteRef,
  }),
);
